import dark from "./dark";
import normal from "./normal";

const styles = {
  normal: normal,
  dark: dark
};

export default styles;